"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var ToggleButtonTheme = function ToggleButtonTheme(colors) {
  return {
    defaultProps: {
      disableRipple: true,
      value: ''
    },
    styleOverrides: {
      root: {
        fontFamily: 'Barlow',
        textTransform: 'none',
        height: '40px',
        borderRadius: '8px',
        padding: '12px 20px 12px 20px',
        backgroundColor: colors.white,
        color: colors.ultramarine,
        borderColor: colors.grey10,
        '&:hover': {
          backgroundColor: colors.bleuDigital05,
          borderColor: colors.bleuDigital10,
          color: colors.hover
        },
        '&:active': {
          backgroundColor: colors.bleuDigital10,
          borderColor: colors.click,
          color: colors.click
        },
        '&.Mui-selected': {
          color: colors.white,
          backgroundColor: colors.selected,
          borderColor: colors.selected,
          '&:hover': {
            color: colors.white,
            backgroundColor: colors.selected,
            borderColor: colors.selected
          },
          '&:active': {
            backgroundColor: colors.bleuDigital10,
            borderColor: colors.click,
            color: colors.click
          }
        },
        '&.Mui-disabled': {
          borderColor: colors.grey10,
          color: colors.grey30,
          backgroundColor: colors.white,
          borderWidth: 1
        }
      }
    }
  };
};

var _default = ToggleButtonTheme;
exports["default"] = _default;